import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

interface Option {
  label: string;
  value: string | boolean | number;
}
interface DropdownStatusNewProps {
  name?: string;
  initialValue?: any | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  classNamePrefix?: string;
  isHasOptionAll?: boolean;
  optionAll?: undefined | Option;
  colors?: any;
}

const DropdownStatusNew = ({
  name = "",
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = "",
  classNamePrefix = "",
  isHasOptionAll = false,
  optionAll,
  colors = {},
}: DropdownStatusNewProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const result: any = isHasOptionAll
      ? [optionAll].concat(dataList)
      : dataList;
    setOptions((_prev: any) => result);
  }, [dataList, i18n?.language]);

  return (
    <React.Fragment>
      <Select
        options={options}
        value={
          initialValue || initialValue === 0 || isHasOptionAll
            ? options.find((item: any) => item.value === initialValue)
            : null
        }
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ""}</div>}
        loadingMessage={() => <div>{t("Loading")}...</div>}
        noOptionsMessage={() => <div>{t("No Options")}</div>}
        formatOptionLabel={(option: any) => (
          <div className="d-flex align-items-center" style={{ zIndex: 999 }}>
            <span
              className={`bg-${(option?.value !== "" && option?.value !== "all") ? colors?.[option?.value] : "secondary"
                }`}
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "3px",
                background: colors?.[option?.value],
              }}
            ></span>
            <div className="ms-2">{t(option?.label)}</div>
          </div>
        )}
        className={className}
        classNamePrefix={classNamePrefix}
        menuPortalTarget={document.body}
        styles={{
          control: (styles: any, { isFocused }: any) => {
            return {
              ...styles,
              borderColor: "#e9ebec",
              borderRadius: "0.6rem",
              color: "white",
              "&:hover": { borderColor: "#009ef7" },
            };
          },
          menuPortal: (base: any) => ({
            ...base,
            zIndex: 1501,
          }),
        }}
      />
    </React.Fragment>
  );
};

export default DropdownStatusNew;
